import React, { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import { updateHeaderColor, updateMobileHeaderColor } from '../../utils/scroll';
import { convertNewlineToBr } from '../../utils/util';
import { isMobile } from '../../config';
import randomstring from 'randomstring';

import { fetchInquiryInsertData } from '../../services/inquiryService';

import HeaderComponents from '../../components/Header/HeaderComponents';
import SideBannerComponents from '../../components/SideBanner/SideBannerComp';
import BasicTable from '../../components/Table/BasicTable';
import Input from '../../components/Input/Input';
import useInput from '../../hooks/useInput';
import BasicTextarea from '../../components/Textarea/BasicTextarea';

import security from '../../assets/images/common/security.png';

import S from './Support.module.css';

const InquiryRegPage = () => {

  const [formData, setFormData] = useInput({
    title: '',
    pwd: '',
    cpnName: '',
    staffName: '',
    phone: '',
    email: '',
    use: '',
    prd: '',
    quantity: '',
    content: '',
    security: '',
  });
  const [allAgreed, setAllAgreed] = useState(false); 
  const [agreement, setAgreement] = useState(false);
  const [individualAgreements, setIndividualAgreements] = useState({
    phoneAgreeYn: false,
    emailAgreeYn: false,
  });
  const [securityCode, setSecurityCode] = useState('');
  const [iqFile, setIqFile] = useState([]);
  
  const headerData = [
    { text: '', value: 'title', widthClass: 'inquertRegHeader' },
    { text: '', value: 'content', widthClass: 'inquertRegHeader' },
  ]

  const generateSecurityCode = () => {
    const code = randomstring.generate({ length: 5, charset: 'alphanumeric' });
    setSecurityCode(code);
  };

  const bodyData = [
    {
      title: { text: (<>제목 <span className={S.fontRed}>*</span></>), className: 'iqTableBorder' ,url: null},
      content: { text: (<Input type="text" id='iqTitle' placeholder='제목을 입력해주세요.' name='title' value={formData.title} onChange={setFormData} className='basicInput'/>), className: 'ntTableBorder' },
    },
    {
      title: { text: '비밀번호', className: 'iqTableBorder' },
      content: { text: (<Input type="text" id='iqPwd' placeholder="게시글 조회 시 사용될 비밀번호를 입력해주세요." name='pwd' value={formData.pwd} onChange={setFormData} className='basicInput' />), className: 'ntTableBorder' },
    },
    {
      title: { text: (<>업체명 <span className={S.fontRed}>*</span></>), className: 'iqTableBorder' },
      content: { text: (<Input type="text" id='iqCpnName' placeholder="업체명을 입력해주세요." name='cpnName' value={formData.cpnName} onChange={setFormData} className='basicInput' />), className: 'ntTableBorder' },
    },
    {
      title: { text: (<>담당자명 <span className={S.fontRed}>*</span></>), className: 'iqTableBorder' },
      content: { text: (<Input type="text" id='iqStaffName' placeholder="담당자명을 입력해주세요." name='staffName' value={formData.staffName} onChange={setFormData} className='basicInput' />), className: 'ntTableBorder' },
    },
    {
      title: { text: (<>연락처 <span className={S.fontRed}>*</span></>), className: 'iqTableBorder' },
      content: { text: (<Input type="text" id='iqPhone' placeholder="'-' 을 제외한 숫자만 입력해주세요." name='phone' value={formData.phone} onChange={setFormData} className='basicInput' />), className: 'ntTableBorder' },
    },
    {
      title: { text: (<>이메일 <span className={S.fontRed}>*</span></>), className: 'iqTableBorder' },
      content: { text: (<Input type="text" id='iqEmail' placeholder="올바른 형식의 이메일을 입력해주세요." name='email' value={formData.email} onChange={setFormData} className='basicInput' />), className: 'ntTableBorder' },
    },
    {
      title: { text: '사용용도', className: 'iqTableBorder' },
      content: { text: (<Input type="text" id='iqUse' placeholder="사용 용도를 입력해주세요." name='use' value={formData.use} onChange={setFormData} className='basicInput' />), className: 'ntTableBorder' },
    },
    {
      title: { text: '구매제품', className: 'iqTableBorder' },
      content: { text: (<Input type="text" id='iqPrd' placeholder="구매 제품을 입력해주세요." name='prd' value={formData.prd} onChange={setFormData} className='basicInput' />), className: 'ntTableBorder' },
    },
    {
      title: { text: '구매수량', className: 'iqTableBorder' },
      content: { text: (<Input type="number" id='iqQuantity' placeholder="숫자만 입력해주세요." name='quantity' value={formData.quantity} onChange={setFormData} className='basicInput' />), className: 'ntTableBorder' },
    },
    {
      title: { text: (<>문의내용 <span className={S.fontRed}>*</span></>), className: 'iqTableBorder' },
      content: { text: (<BasicTextarea id='iqContent' type="text" placeholder="문의 내용을 입력해주세요." name='content' value={formData.content} onChange={setFormData} className='basicTextarea' />), className: 'ntTableBorder' },
    },
    {
      title: { text: '첨부파일', className: 'iqTableBorder' },
      content: { text: (<Input type="file" multiple name='' value={formData.file} onChange={(e) => handleFile(e)} />), className: 'ntTableBorder' },
    },
    {
      title: { text: (<>보안문자 <span className={S.fontRed}>*</span></>), className: 'iqTableBorder' },
      content: { text: (
        <div className={isMobile() ? 'flex-column' : 'flex-row'}>
          <div id={S.iqScTextDiv}>
            <img src={security} alt=""/>
            <p className='draggable' readOnly id={S.iqScText}>{securityCode}</p>
          </div>
          <div id={S.iqScInputDiv}>
            <Input type="text" name='security' id='iqSecurity' value={formData.security} onChange={setFormData} className='shortInput'/> 
            <button onClick={generateSecurityCode} type='button'>새로고침</button>
          </div>
        </div>
      ), className: 'ntTableBorder' },
    },
  ];

  const navigate = useNavigate();


  useEffect(() => {
    window.scrollTo(0, 327);
    
    generateSecurityCode();
  }, []);
  
  useEffect(() => {
    const wheelHandler = (e) => {
      if(isMobile()) {
        updateMobileHeaderColor();
      } else {
        updateHeaderColor();
      }
    };

    window.addEventListener('scroll', wheelHandler);

    return () => {
      window.removeEventListener('scroll', wheelHandler);
    };
  }, []);
  
  const handleFile = (e) => {
    setIqFile(e.target.files);
  }

  const handleAllAgreeChange = (e) => {
    const isChecked = e.target.checked;
    setAllAgreed(isChecked); 
    setAgreement(isChecked);
    setIndividualAgreements({
      phoneAgreeYn: isChecked,
      emailAgreeYn: isChecked,
    });
  };

  const handleIndividualChange = (e) => {
    const { name, checked } = e.target;
    if (name === "agreement") {
      setAgreement(checked); 
    } else {
      setIndividualAgreements((prev) => ({
        ...prev,
        [name]: checked,
      }));
    }

    setAllAgreed(
    name === "agreement"
      ? checked &&
        Object.values({ ...individualAgreements }).every((v) => v) 
      : agreement && Object.values({ ...individualAgreements, [name]: checked }).every((v) => v)
    );
    
  }; 

  const handleSubmit  = async () => {

    const data = new FormData();
    data.append('title', formData.title);
    data.append('pwd', formData.pwd);
    data.append('cpnName', formData.cpnName);
    data.append('staffName', formData.staffName);
    data.append('phone', formData.phone);
    data.append('email', formData.email);
    data.append('use', formData.use);
    data.append('prd', formData.prd);
    data.append('quantity', formData.quantity);
    data.append('content', convertNewlineToBr(formData.content));
    data.append('pwdYn', formData.pwd.length > 0 ? 'Y' : 'N' );
    data.append('security', formData.security );
    data.append('agreement', agreement );
    data.append('phoneAgreeYn', individualAgreements.phoneAgreeYn ? 'Y' : 'N' );
    data.append('emailAgreeYn', individualAgreements.emailAgreeYn ? 'Y' : 'N' );

    for (let i = 0; i < iqFile.length; i++) {
      data.append('iqFile', iqFile[i]);
    }
    
    const response = await fetchInquiryInsertData(data, formData, agreement, securityCode);

    if (response) {
      if(response.status === 200) {
        alert('문의사항이 등록되었습니다.');
        navigate('/support/inquiry/1');
      } else {
        alert('문의사항 등록 중 오류가 발생하였습니다. \n 관리자에게 문의해주세요.');
      }
    }
  }
  
  return (
    <div>
      <HeaderComponents pageKey="support" />
      <div className='sideBannerComp flex-coulum'>
        <div>
          <SideBannerComponents pageKey="support" />
        </div>
          <div className='com-content-wrap mt-200' id={S.iqTableWrap}>
            <div style={{minHeight:'650px'}}>
              <BasicTable headers={headerData} items={bodyData} />
              
              <div style={{textAlign: 'center', fontWeight: '700', marginTop: '30px'}}>
                <input type="checkbox" name='allAgreeYn' id='allAgreeYn' checked={allAgreed} onChange={handleAllAgreeChange} className={S.checkbox}/> 
                <label htmlFor="allAgreeYn" className={S.inputLabel}>전체동의</label> <br></br>
              </div>

              <div id={S.iqAgreedWrap} className='draggable'>
                <div id={S.agreedText}>
                  <p>개인정보 수집 및 이용동의(필수)</p>
                  <p>- 수집 항목 : 제목, 비밀번호, 업체명, 담당자명, 연락처, 이메일 및 그 외 개인이 직접 입력한 내용<br></br>
                      - 수집 목적 : 문의사항접수 및 결과 회신을 위한 경로 확보<br></br>
                      - 이용 기간 : 원칙적으로, 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체없이 파기합니다.<br></br>
                      단, 관계법령의 규정에 의하여 보존할 필요가 있는 경우 아래와 같이 관계법령에서 정한 일정 기간 동안 개인정보를<br></br>                    
                      보관할 수 있습니다.<br></br>
                      - 소비자의 불만 또는 분쟁처리에 관한 기록 : 3년 (전자상거래등에서의 소비자보호에 관한 법률)<br></br>
                      - 위의 개인정보 소집 및 이용에 동의합니다.(동의 후 문의가 가능합니다.)                    
                  </p>
                </div>
                <div style={{display: 'flex', justifyContent: 'end'}}>
                  <div>
                    <input type="checkbox" name='agreement' id='round-checkbox' checked={agreement} required onChange={handleIndividualChange} className={S.checkbox}/> 
                    <label htmlFor="round-checkbox" className={S.inputLabel}>개인정보 수집 및 이용동의(필수)</label> <br></br>
                  </div>
                </div>
              </div>

              <div id={S.iqAgreedWrap} className='draggable'>
              <div id={S.agreedText}>
                <p>마케팅 활용 동의 및 광고 수신 동의</p>
                <p>서비스와 관련된 신상품 소식, 이벤트 안내, 고객 혜택 등 다양한 정보를 제공합니다.</p>
              </div>
              <div style={{display: 'flex', justifyContent: 'end'}}>
                <div>
                  <input type="checkbox" name='phoneAgreeYn' id='phoneAgreeYn' checked={individualAgreements.phoneAgreeYn} required onChange={handleIndividualChange} className={S.checkbox}/> 
                  <label htmlFor="phoneAgreeYn" className={S.inputLabel}>문자 수신 동의(선택)</label> <br></br>
                </div>
                <div>
                  <input type="checkbox" name='emailAgreeYn' id='emailAgreeYn' checked={individualAgreements.emailAgreeYn} required onChange={handleIndividualChange} className={S.checkbox}/> 
                  <label htmlFor="emailAgreeYn" className={S.inputLabel}>E-Mail 수신 동의(선택)</label> <br></br>
                </div>
              </div>
              </div>
              <div onClick={handleSubmit} className={isMobile() ? S.iqBlackBtn : S.blackBtn}>
                등록
              </div>
            </div>
          </div>
      </div>
    </div>
  );
};

export default InquiryRegPage;
